import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Forecasts*/
export const registerForecast = async (forecastData) => {
  try {
    const response = await api.post("/forecast", forecastData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

// Funnel column id -> API query parameter. The `f_` prefix keeps these apart
// from the dropdown filters above the table (commodity/plant/period), which
// match exactly while these match on "contains".
const FUNNEL_PARAMS = {
  vendor_name: 'f_vendor_name',
  forecast_month: 'f_forecast_month',
  version: 'f_version',
  commodity: 'f_commodity',
  feedback_status: 'f_feedback_status',
};

export const fetchForecastsFromAPI = async (page = 1, perPage = 10, search = {}, columnFilters = {}, sort = {}) => {
  try {
    // Ensure search is an object and merge with pagination params
    const searchParams = typeof search === 'object' ? search : {};

    const params = {
      page,
      per_page: perPage,
      ...searchParams
    };

    Object.entries(FUNNEL_PARAMS).forEach(([columnId, param]) => {
      const value = columnFilters?.[columnId];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        params[param] = String(value).trim();
      }
    });

    // Server-side sort (column id + direction).
    if (sort?.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }
    
    console.log("🌐 ForecastService - fetchForecastsFromAPI called with params:", params);
    
    const response = await api.get("/forecast/header", {
      params: params,
    });

    console.log("🌐 ForecastService - API response received:", response.data);

    return response.data.data;
  } catch (error) {
    console.log("🌐 ForecastService - API error:", error);
    const fallback = generateErrorMessage("get data", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteForecastsFromAPI = async (forecastId) => {
  try {
    const response = await api.delete(`/forecast/${forecastId}`, {
      params: { forecast_id: forecastId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchForecastsById = async (forecastId) => {
  try {
    const response = await api.get(`/forecast/${forecastId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data forecast", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateForecast = async (id, forecastData) => {
  try {
    const response = await api.put(`/forecast/${id}`, forecastData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const uploadForecastFileToAPI = async (formData) => {
  try {
    const response = await api.post("/inventories/submit-excel-forecast", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const uploadForecastJsonToAPI = async ({ forecastData, forecastMonth, commodity, plant, fileName }) => {
  try {
    const response = await api.post("/forecast/submit-json", {
      forecastData,
      forecastMonth,
      commodity,
      plant,
      fileName
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload forecast JSON", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const validateForecastFileToAPI = async (fileName) => {
  try {
    const response = await api.post("/forecast/validate-file", {
      fileName
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("validate forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const downloadForecastFileFromAPI = async (fileType, vendorCode, forecastMonth, commodity, plant) => {
  try {
    // Convert forecastMonth from "YYYY-MM" to "YYYYMM"
    const formattedForecastMonth = forecastMonth.replace("-", "");

    const response = await api.post(`/inventories/download/${fileType}/${vendorCode}/${formattedForecastMonth}/${commodity}/${plant || ''}`);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;

      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
